import axios from "axios";
import routes from "./routes";

const environment = process.env.VUE_APP_ENVIRONMENT;
const domainDev = '.nep.test';
const domainStaging = '.firstresponderprocessing.dev';
const domainProduction = '.firstresponderprocessing.com';

let activeDomain = '';

switch(environment) {
	case 'STAGING':
		activeDomain = domainStaging
		break;
	case 'PRODUCTION':
		activeDomain = domainProduction
		break;
	case 'DEVELOPMENT':
	default:
		activeDomain = domainDev
		break;
}

const api = axios.create({
	baseURL: window.location.protocol + '//cms' + activeDomain,
});

export { api, routes, environment, activeDomain}
